import React, { useState } from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router-dom";

const PricingPlans = () => {
  const [duration, setDuration] = useState(12);

  //  Utility for currency formatting (EN → €15,000 | FR → 15.000 €)
  const formatPrice = (value) => {
    const lang = localStorage.getItem("lang") || "en"; // fallback

    if (lang === "en") {
      // EN → €15,000
      return `€${value.toLocaleString("en-EN")}`;
    } else if (lang === "fr") {
      // FR → 15.000 €
      return `${value.toLocaleString("fr-FR").replace(/\s/g, ".")} €`;
    }

    // Default fallback
    return `€${value}`;
  };
  // Pricing based on duration
  const pricing = {
    12: {
      BASIC: 1800,
      PROFESSIONAL: 5500,
      ORGANIZATION: 15000,
    },
    24: {
      BASIC: 1530,
      PROFESSIONAL: 4675,
      ORGANIZATION: 12750,
    },
    36: {
      BASIC: 1350,
      PROFESSIONAL: 4125,
      ORGANIZATION: 11250,
    },
  };

  // Feature keys (for translations)
  const featureIds = [
    "head.register",
    "corporate.link1",
    "corporate.link2",
    "corporate.link3",
    "corporate.link4",
    "corporate.link5",
  ];

  // Plan-specific feature values (numbers instead of € strings)
  const planFeatures = {
    FREE: ["✔", "✔", "✔", "0", 200, 400],
    BASIC: ["✔", "✔", "✔", "0-150", 150, 240],
    PROFESSIONAL: ["✔", "✔", "✔", "151-500", 125, 200],
    ORGANIZATION: ["✔", "✔", "✔", "501-5000", 87.5, 140],
  };

  // Render feature rows
  const renderFeatures = (plan) => (
    <ul className="list-unstyled mt-auto border-top pt-3">
      {featureIds.map((id, i) => (
        <li
          key={i}
          className="py-2 border-bottom d-flex justify-content-between align-items-center"
          style={{ fontSize: "11px", textAlign: "left" }}
        >
          {/* Left aligned feature text */}
          <span className="flex-grow-1 text-start">
            <FormattedHTMLMessage id={id} />
          </span>

          {/* Right aligned feature value */}
          <span
            className="text-end fw-semibold text-dark ms-2"
            style={{ minWidth: "70px", textAlign: "right" }}
          >
            {typeof planFeatures[plan][i] === "number"
              ? formatPrice(planFeatures[plan][i])
              : planFeatures[plan][i]}
          </span>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="container" style={{ marginTop: "6rem" }}>
      {/* Top Title */}
      <h2 className="text-center mb-5 fw-bold">
        <FormattedHTMLMessage
          id="corporate.title"
          defaultMessage="Annual subscriptions reduced rates CORPORATE code (excl. VAT)"
        />
      </h2>

      {/* Subscription Duration Buttons */}
      <div
        className="d-flex justify-content-center mb-5"
        style={{ gap: "1.5rem" }}
      >
        {/* 12 months */}
        <div className="position-relative d-inline-block">
          <button
            className={`btn px-4 rounded-pill fw-bold ${duration === 12
                ? "btn-dark text-white"
                : "btn-light border border-dark"
              }`}
            onClick={() => setDuration(12)}
          >
            <FormattedHTMLMessage id="corporate.12months" />
          </button>
        </div>

        {/* 24 months with badge */}
        <div className="position-relative d-inline-block">
          <button
            className={`btn px-4 rounded-pill fw-bold ${duration === 24
                ? "btn-dark text-white"
                : "btn-light border border-dark"
              }`}
            onClick={() => setDuration(24)}
          >
            <FormattedHTMLMessage id="corporate.24months" />
          </button>
          <span
            className="badge bg-warning text-dark fw-bold px-2 py-1 rounded-pill position-absolute"
            style={{ top: "-10px", right: "-10px", fontSize: "10px" }}
          >
            <FormattedHTMLMessage id="corporate.save15" />
          </span>
        </div>

        {/* 36 months with badge */}
        <div className="position-relative d-inline-block">
          <button
            className={`btn px-4 rounded-pill fw-bold ${duration === 36
                ? "btn-dark text-white"
                : "btn-light border border-dark"
              }`}
            onClick={() => setDuration(36)}
          >
            <FormattedHTMLMessage id="corporate.36months" />
          </button>
          <span
            className="badge bg-warning text-dark fw-bold px-2 py-1 rounded-pill position-absolute"
            style={{ top: "-10px", right: "-10px", fontSize: "10px" }}
          >
            <FormattedHTMLMessage id="corporate.save25" />
          </span>
        </div>
      </div>

      {/* Pricing Plans */}
      <div className="row text-center">
        {/* FREE */}
        <div className="col-md-3 mb-4">
          <div className="card h-100 border shadow-sm">
            <div className="card-body d-flex flex-column">
              <h4
                className="card-title"
                style={{ fontSize: "20px", marginTop: "16%" }}
              >
                FREE
              </h4>
              <p>
                <FormattedHTMLMessage id="corporate.text" />
              </p>
              <h3>{formatPrice(0)}</h3>
              <Link
                to="/contact-us"
                className="nav-link"
                data-target=".navbar-collapse.show"
                onClick={() => localStorage.setItem("planOrigin", "FREE")}
              >
                <button className="btn btn-outline-dark mb-3 w-100">
                  <FormattedHTMLMessage id="corporate.text2" />
                </button>
              </Link>
              {/* {renderFeatures("FREE")} */}
            </div>
          </div>
        </div>

        {/* BASIC */}
        <div className="col-md-3 mb-4">
          {/* <div  style={{ background: "#0a0a0aff", border: "none", padding: "8px", color:"#ffff", fontSize:"13px", }}>
                <FormattedHTMLMessage id="black-friday-15" defaultMessage="Classic"/>
            </div> */}
          <div className="card h-100 border shadow-sm">
            <div className="card-body d-flex flex-column">
              <h4
                className="card-title"
                style={{ fontSize: "20px", marginTop: "16%" }}
              >
                <FormattedHTMLMessage id={`corporate.basic.title.${duration}`} />
              </h4>
              <p><FormattedHTMLMessage id="corporate.basic.sub" /></p>
              <h3><FormattedHTMLMessage id={`corporate.basic.price.${duration}`} /></h3>
              <Link
                to="/contact-us"
                className="nav-link"
                data-target=".navbar-collapse.show"
                onClick={() => localStorage.setItem("planOrigin", "BASIC")}
              >
                <button className="btn btn-warning mb-3 w-100">
                  <FormattedHTMLMessage id="corporate.text3" />
                </button>
              </Link>
              {/* {renderFeatures("BASIC")} */}
            </div>
          </div>
        </div>

        {/* PROFESSIONAL */}
        <div className="col-md-3 mb-4">
          {/* <div  style={{ background: "#0a0a0aff", border: "none", padding: "8px", color:"#ffff", fontSize:"13px", }}>
                <FormattedHTMLMessage id="black-friday-25" defaultMessage="Classic"/>
            </div> */}
          <div className="card h-100 border shadow-sm position-relative">
            <span
              className="position-absolute top-0 start-50 translate-middle badge bg-dark text-white"
              style={{ zIndex: 20 }}
            >
              <FormattedHTMLMessage id="corporate.text6" />
            </span>
            <div className="card-body d-flex flex-column mt-4">
              <h4
                className="card-title"
                style={{ fontSize: "20px", marginTop: "6%" }}
              >
                <FormattedHTMLMessage id={`corporate.prof.title.${duration}`} />
              </h4>
              <p><FormattedHTMLMessage id="corporate.prof.sub" /></p>
              <h3><FormattedHTMLMessage id={`corporate.prof.price.${duration}`} /></h3>
              <Link
                to="/contact-us"
                className="nav-link"
                data-target=".navbar-collapse.show"
                onClick={() =>
                  localStorage.setItem("planOrigin", "PROFESSIONAL")
                }
              >
                <button className="btn btn-dark mb-3 w-100">
                  <FormattedHTMLMessage id="corporate.text4" />
                </button>
              </Link>
              {/* {renderFeatures("PROFESSIONAL")} */}
            </div>
          </div>
        </div>

        {/* ORGANIZATION */}
        <div className="col-md-3 mb-4">
          {/* <div  style={{ background: "#0a0a0aff", border: "none", padding: "8px", color:"#ffff", fontSize:"13px", }}>
                <FormattedHTMLMessage id="black-friday-35" defaultMessage="Classic"/>
            </div> */}
          <div className="card h-100 border shadow-sm">
            <div className="card-body d-flex flex-column">
              <h4
                className="card-title"
                style={{ fontSize: "20px", marginTop: "16%" }}
              >
                <FormattedHTMLMessage id={`corporate.org.title.${duration}`} />
              </h4>
              <p><FormattedHTMLMessage id="corporate.org.sub" /></p>
              <h3><FormattedHTMLMessage id={`corporate.org.price.${duration}`} /></h3>
              <Link
                to="/contact-us"
                className="nav-link"
                data-target=".navbar-collapse.show"
                onClick={() =>
                  localStorage.setItem("planOrigin", "ORGANIZATION")
                }
              >
                <button className="btn btn-warning mb-3 w-100">
                  <FormattedHTMLMessage id="corporate.text5" />
                </button>
              </Link>
              {/* {renderFeatures("ORGANIZATION")} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
